'use client'

import {observer} from 'mobx-react'
import React from 'react'

import {Breadcrumbs} from './breadcrumbs'
import * as UI from './meta.styled'

export interface IProps {
  breadcrumbs: BreadcrumbItem[]
  title?: React.ReactNode
  className?: string
}

export const EmptyMeta: PageMeta = {title: '', description: '', keywords: ''}

export const LayoutMeta = observer(({breadcrumbs, title, className}: IProps) => {
  return (
    <UI.Wrapper className={className}>
      {(breadcrumbs?.length > 0 && <Breadcrumbs items={breadcrumbs} />) || null}
      {title}
    </UI.Wrapper>
  )
})
